import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Modal } from 'react-bootstrap';
import { DataManager } from '../../../core/data-manager';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ModalEntityCompiler from '../../../components/Modals/ModalEntityCompiler';



export default function DGLTH_gyv_mpm({ item, entity = null}) {

    const navigate = useNavigate();

    //delete
    const [modalDeleteStatus, setModalDeleteStatus] = useState(false);
    function deleteMpm() {
        setModalDeleteStatus(true)
    }
    async function handleConfirmDelete() {
        let response = await DataManager.deleteItem('manufacturing_process_model', item.id)
        if(response.success === 1) {
            document.querySelector("tr[data-id='"+item.id+"'][data-entity='"+entity+"']").remove();
        }
    }


    //view
    function viewMpm() {
        navigate('/page/MpmTree2?id=' + item.id)
    }

    //print
    function printMpm() {
        navigate('/page/MpmPrint?id=' + item.id)
    }


    //duplicate
    const [modalCompilerStatus, setModalCompilerStatus] = useState(false)
    const [modalCompilerInitData, setModalCompilerInitData] = useState(null)
    function closeModalCompiler() {
        setModalCompilerInitData(null)
    }

    useEffect(() => {
        if(modalCompilerInitData !== null) {
            setModalCompilerStatus(true)
        }
        else {
            setModalCompilerStatus(false)
        }
    }, [modalCompilerInitData]);

    async function modalCompilerSave(el) {
        console.log(el)
        var response = await DataManager.insertItem('manufacturing_process_model', el);
        if(response.success === 1) {
            navigate(0);
        }
        else {
            console.warn(response)
        }
        setModalCompilerInitData(null)
    }

    async function duplicateMpm() {
        var response = await DataManager.getItem('manufacturing_process_model', item.id);
        if(response.success === 1) {
            const {idItemModel, ...rest} = response.body[0]
            setModalCompilerInitData(rest)
        }
        else {
            setModalCompilerInitData({})
        }
    }



    return (
        <>
            {item ? (
                <>
                    <Button onClick={viewMpm} className='m-1' variant='primary' size='sm'><FontAwesomeIcon icon={'folder-tree'} className='me-1' />Visualizza</Button>
                    <Button onClick={printMpm} className='m-1' variant='secondary' size='sm'><FontAwesomeIcon icon={'print'} /></Button>
                    <Button onClick={duplicateMpm} className='m-1' variant='info' size='sm'><FontAwesomeIcon icon={'copy'} className='me-1' />Duplica</Button>

                    {modalCompilerStatus !== false ? (
                        <ModalEntityCompiler entity={'manufacturing_process_model'} initData={modalCompilerInitData} close={closeModalCompiler} status={modalCompilerStatus} confirmCallback={modalCompilerSave} />
                    ) : (
                        <></>
                    )}
                </>
            ) : (
                <></>
            )}

            <Button onClick={deleteMpm} className='m-1' variant='danger' size='sm'><FontAwesomeIcon icon={'times'} className='me-1' />Elimina</Button>
        

            {modalDeleteStatus !== false ? (
                <Modal show={modalDeleteStatus} onHide={() => setModalDeleteStatus(false)}>
                    <Modal.Header closeButton>
                    <Modal.Title>Eliminazione</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Confermi di voler rimuovere questa distinta?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setModalDeleteStatus(false)}>
                            Chiudi
                        </Button>
                        <Button variant="danger" onClick={handleConfirmDelete}>
                            Conferma
                        </Button>
                    </Modal.Footer>
                </Modal>
            ) : (
                <></>
            )}
        </>
    )
};